import { useModuleRedirect } from "../../hooks/useModuleRedirect";

const WashroomManagementEntry = () => {
  useModuleRedirect("washroom-management");
  return null;
};

export default WashroomManagementEntry;